'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width : 100%;\n    position : relative;\n    font-family: \'Open Sans\', sans-serif;\n'], ['\n    width : 100%;\n    position : relative;\n    font-family: \'Open Sans\', sans-serif;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);
exports.default = Container;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/Container.js
// module id = 479
// module chunks = 0